import { darkPalette } from "../palette";

export const MuiTexField = {
  MuiTextField: {
    styleOverrides: {
      root: {
        backgroundColor: "transparent",
        "& fieldset": {
          borderColor: darkPalette.primary.main,
        },
        "& input, & .MuiInputBase-root": {
          color: darkPalette.text.primary,
          backgroundColor: "transparent",
        },
        ".MuiInputBase-root.MuiOutlinedInput-root:hover fieldset": {
          borderColor: darkPalette.text.primary,
        },
      },
      outlined: {},
      contained: {},
    },
  },
};
